import styled from 'styled-components';

const IndexStyled = styled.div`
  .user-search-box {
    padding: 20px;
    background-color: #fff;
    border-radius: 2px;
  }
  .user-search-back {
    width: 100%;
  }
  .user-search-wrap {
    padding: 66px 133px 66px 139px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user-search-icon {
      width: 64px;
      margin-right: 40px;
    }
    .user-search-text {
      margin-bottom: 8px;
    }
  }
  .button-group {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: 56px;
    .reset {
      margin-right: 16px;
    }
    .search {
      margin-right: 0;
    }
  }
  .user-search-content {
    margin-top: 20px;
    .user-search-item {
      width: 50%;
      padding: 10px;
      background-color: #fff;
      display: flex;
      gap: 30px;
      .user-search-item-img {
        width: 150px;
        height: 150px;
      }
      .user-search-item-right {
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .user-search-item-right-info {
          display: flex;
          flex-direction: column;
          gap: 10px;
          .user-name {
            padding: 4px 10px 4px 10px;
            border-radius: 8px;
            background: #ebebeb;
            display: flex;
            align-items: center;
            gap: 10px;
            width: max-content;
            .user-icon {
              width: 16px;
              height: 16px;
            }
            .user-name-info {
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: 0px;
              color: #212100;
            }
          }
          .user-email {
            margin-left: 10px;
            .user-email-label {
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              letter-spacing: 0px;
              color: #999999;
            }
            .user-email-value {
              margin-top: 8px;
              font-size: 14px;
              font-weight: 400;
              line-height: 17px;
              letter-spacing: 0px;
              color: #000000;
            }
          }
        }
        .user-search-item-right-reset-wrap {
          cursor: pointer;
          margin-left: 10px;
          display: flex;
          align-items: center;
          .user-search-item-right-reset-icon {
            width: 16px;
            margin-right: 4px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0px;
            color: #000000;
          }
        }
      }
    }
  }
  .user-search-no-data {
    margin-top: 80px;
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 48px;
      margin-bottom: 12px;
    }
    .word-h1 {
      font-size: 24px;
      font-weight: 400;
      line-height: 34px;
      letter-spacing: 0px;
      text-align: center;
      margin-bottom: 4px;
      color: #000000;
    }
    .word-h2 {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: center;
      color: #8c8c8c;
    }
  }
`;
export default IndexStyled;
